import React from "react";

export default function FooterText() {
  return <div style={{textAlign: "center", color: "silver"}}>世济其美(广州)技术服务有限公司 &copy; {new Date().getFullYear()}</div>;
}